import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { interval, EMPTY, Subscription } from "rxjs";
import { switchMap, startWith } from "rxjs/operators";
import { UserInfoService } from "./user-info.service";
import { environment } from "src/environments/environment";

@Injectable({ providedIn: "root" })
export class HeartbeatService {
  private subscription: Subscription | null = null;
  private apiUrl = environment.apiUrl + "api/Heartbeat/";

  constructor(
    private http: HttpClient
  ) {}

  start(userId: number) {
    this.subscription = interval(60000)
      .pipe(
        startWith(0),
        switchMap(() => {
          return this.http.post(this.apiUrl + userId, null);
        }),
      )
      .subscribe({
        //next: (response) => console.log("Heartbeat response: " + userId + new Date(), response),
        error: (err) => console.error("Heartbeat failed", err),
      });
  }

  stop() {
    console.log("Stopping Heartbeat: " + new Date());
    this.subscription?.unsubscribe();
  }
}
